import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate"

import user from './modules/user'
import getters from './getters.js'
import device from './modules/device'
import dict from './modules/dict'
import token from './modules/token'
import task from './modules/task'
import settings from './modules/settings'
import tagsView from './modules/tagsView'
import cookie from './modules/cookie'

Vue.use(Vuex)
const store = new Vuex.Store({
  modules: {
    user,
    device,
    dict,
    token,
    task,
    settings,
    tagsView,
    cookie,
  },
  getters,
  plugins: [createPersistedState({
    storage: window.sessionStorage, // 同localStorage相同，只是将vuex的所有值存储到sessionStorage中
    reducer: (state) => ({
      userInfo: state.user.userInfo,
    }),
  })]
})

export default store
